import fetchProductPromotions from "@faire/web-api/api/product/productToken/product-promo-messages/get";
import { IInformationMessage } from "@faire/web-api/indigofair/data/IInformationMessage";
import { IInsiderLabel } from "@faire/web-api/indigofair/data/IInsiderLabel";
import { IProductPromoMessagesResponse } from "@faire/web-api/indigofair/data/IProductPromoMessagesResponse";
import { fulfilledOrStale } from "@faire/web/common/instanceUtils";
import { makeObservable } from "@faire/web/common/makeObservable";
import { computed, observable } from "mobx";
import { fromPromise, IPromiseBasedObservable } from "mobx-utils";

export class ProductPromotionState {
  @observable
  private productPromotionResponse?: IPromiseBasedObservable<IProductPromoMessagesResponse>;

  constructor(private readonly productToken: string) {
    makeObservable(this);
  }

  fetchProductPromotions = () => {
    this.productPromotionResponse = fromPromise(
      fetchProductPromotions(this.productToken),
      this.productPromotionResponse
    );
  };

  @computed
  private get productPromotions(): IInformationMessage[] {
    return (
      fulfilledOrStale(this.productPromotionResponse, "promo_messages")
        ?.promo_messages ?? []
    );
  }

  @computed
  get insiderLabel(): IInsiderLabel | undefined {
    return fulfilledOrStale(this.productPromotionResponse, "insider_label")
      ?.insider_label;
  }

  @computed
  get promotionLabel(): IInformationMessage | undefined {
    return fulfilledOrStale(this.productPromotionResponse, "promo_label")
      ?.promo_label;
  }

  @computed
  get nonFashionWeekPromos() {
    return this.productPromotions?.filter(
      (promotion) =>
        promotion.type !== IInformationMessage.Type.FAIRE_FUNDED_PROMO_BANNER
    );
  }

  @computed
  get marketPromo() {
    return this.productPromotions?.find(
      (promotion) => promotion.type === IInformationMessage.Type.MARKET_PROMO
    );
  }

  @computed
  get promotionStyleBanners() {
    return this.nonFashionWeekPromos?.filter(
      (promotion) => promotion.style === IInformationMessage.Style.PROMO
    );
  }

  @computed
  get nonPromotionStyleBanners() {
    return this.nonFashionWeekPromos?.filter(
      (promotion) => promotion.style !== IInformationMessage.Style.PROMO
    );
  }

  @computed
  get guaranteedFreeShippingPromo() {
    return this.productPromotions?.find(
      (promotion) =>
        promotion.type ===
        IInformationMessage.Type.GUARANTEED_FREE_SHIPPING_THRESHOLD
    );
  }
}
